window.scrollInit = function() {
	if (window.innerWidth > 1199) {
		$('.js-scroll').mCustomScrollbar({
			mouseWheelPixels: 80,
			scrollInertia: 0,
			liveSelector: 'tbody',
			callbacks: {
				onTotalScroll: function () {
					$(this).trigger('totalScroll');
				},
			},
		});
	}
}

scrollInit();